import { useEmiTable } from "components/table";

// Sorting is server-driven (manualSorting), so the table instance just carries
// the sort-column state and header helpers; it never computes row order itself.
const useModelTaskTableInstance = ({ data, columnDefs, sorting, onSortingChange }) => {
	const table = useEmiTable({
		data,
		columns: columnDefs,
		state: { sorting },
		onSortingChange,
		manualSorting: true,
	});
	return { table, rows: table.getRowModel().rows };
};

export default useModelTaskTableInstance;
